module.exports = __webpack_public_path__ + "static/media/lead_closed_card_corner.d0500a27.svg";